import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from "@mui/material/Box";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { v4 as uuidv4 } from 'uuid';
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import FormHelperText from '@mui/material/FormHelperText';
import sortBy from "lodash/sortBy";
import { useOutletContext } from "react-router-dom";

const AddSubFolderActionDialog = ({ open, setOpen, parentItemObjData, setParentItemObjData, targetItemObjData, setTargetItemObjData, compositeFolderArrayInsideRoot, setCompositeFolderArrayInsideRoot }) => {

    const { loggedInUser } = useGetLoggedInUserDetails();
    const { emailAddress } = loggedInUser;

    // console.log("compositeFolderArrayInsideRoot-parentItemObjData11111:", parentItemObjData)

    /**
     * parentItemObjData gives complete folder data object for computation
     */

    useEffect(() => {
        if (!!open) {
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [open])

    const schema = yup.object().shape({
        sub_folder_name: yup.string().label('This field').required().max(50),
    });

    const rhfFormInstanceForPDSubFolderAdd = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            folder_name: "",
            sub_folder_name: "",
        },
    });

    const { setValue, reset, setError, clearErrors, watch } = rhfFormInstanceForPDSubFolderAdd

    const inputSubFolderName = watch('sub_folder_name')


    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
        setParentItemObjData({})
        setTargetItemObjData({})

        reset({ folder_name: "", sub_folder_name: "" })
    };

    /** populate folder name in the form */
    useEffect(() => {
        if (!!parentItemObjData) {
            setValue("folder_name", parentItemObjData?.ResourceFolderName)
        }
    }, [parentItemObjData])



    const onSubmitForPDSubFolderAdd = (data, e) => {

        /**index is required as we want to insert excludedItem at same index in array later. Beacause if we try to merge item into array then it creates that entry at the end of the array. To avoid this and to maintain same position, we need this index to be used in splice method */
        let indexOfExcludedTreeItem = '' /**must be in string */
        let excludedTreeItem = {}
        const arrayWithoutExcludedTreeItem = !!compositeFolderArrayInsideRoot && compositeFolderArrayInsideRoot.filter((eachItem, index) => {

            if (eachItem?.Id !== parentItemObjData?.Id) {
                return eachItem
            } else {
                indexOfExcludedTreeItem = `${index}`
                excludedTreeItem = eachItem
            }

        })
        /**
         *add newly created subfolder to existing subfolder array
         */
        const newModifiedResourceSubFoldersList = [
            ...excludedTreeItem?.ResourceSubFolders,
            {
                Id: uuidv4(),
                ResourceParentFolderid: excludedTreeItem?.Id,
                /**adding this field to all newlyadded items to differntiate from existing one from api response */
                IsNewlyAdded: true,

                IsDeleted: false,
                ResourceSubFolderName: data?.sub_folder_name,
                ProgramDescriptors: [],
                CreatedBy: emailAddress || ""

            }
        ]
        /**sort subfolder array*/
        const inputArrayForSorting = newModifiedResourceSubFoldersList || []

        const sortedSubFolderArray = sortBy(inputArrayForSorting, (item) => {
            const subfolderName = item?.ResourceSubFolderName || ""
            /**we are converting all subfolder names into smallcase for proper aphabetical order */
            return [subfolderName.toLowerCase()];
        });

        /**add modified subFolderArray to folderList */
        const newItem = {
            ...excludedTreeItem,
            ResourceSubFolders: sortedSubFolderArray || []
        }

        // console.log("compositeFolderArrayInsideRoot-iam:", arrayWithoutExcludedTreeItem)

        if (!!indexOfExcludedTreeItem) {
            const index = Number(indexOfExcludedTreeItem)

            /**
             * Inserting Item at specific index in an array:
             * splice(indexWhereToInsertItem, startFromIndex, NewItemToBeInserted)
             */

            arrayWithoutExcludedTreeItem.splice(index, 0, newItem);

            /**as splice modifies original array itself,  arrayWithoutExcludedTreeItem after splice contains inserted newItem at desired index*/

            setCompositeFolderArrayInsideRoot(arrayWithoutExcludedTreeItem)
        }

        handleClose()
    };

    /**folder name validation. at same level same name is not allowed. */
    let arrayOfOnlySubFolderNames = []

    /**subfolder count validation. max 20 subfolders are allowed to create at each folder level. */
    const subFolderList = parentItemObjData?.ResourceSubFolders || []

    let subFolders = !!subFolderList && subFolderList.filter((eachSubFolder) => {
        if (!eachSubFolder?.IsDeleted) {
            arrayOfOnlySubFolderNames.push(eachSubFolder?.ResourceSubFolderName)
            return eachSubFolder?.Id
        }
    })

    const [errorMsg, setErrorMsg] = useState("")
    useEffect(() => {
        /**subFolders name validation. at same level same name is not allowed. */
        if (!!arrayOfOnlySubFolderNames.includes(inputSubFolderName?.trim())) {
            const foldersNameMsg = "This subfolder name exists at this level."
            setErrorMsg(foldersNameMsg)
        }
        /**subFolders count validation. max 20 subFolders are allowed to create for each folder. */
        else if (subFolders.length >= 20) {
            const subFoldersLimitMsg = "Max 20 subFolders could be created at this level."
            setErrorMsg(subFoldersLimitMsg)
        }
        else {
            setErrorMsg("")
        }
    }, [arrayOfOnlySubFolderNames, inputSubFolderName, subFolders])


    /**disabling submit on failing custom validations */
    const [disableSubmitButton, setDisableSubmitButton] = useState(false)
    useEffect(() => {
        if (subFolders.length >= 20) {
            setDisableSubmitButton(true)
        } else if (!!arrayOfOnlySubFolderNames.includes(inputSubFolderName?.trim())) {
            setDisableSubmitButton(true)
        } else {
            setDisableSubmitButton(false)
        }
    }, [subFolders, arrayOfOnlySubFolderNames, inputSubFolderName])

    const resourcesCMSData = useOutletContext();

    const fetchClientAccResDtlsLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
          const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
          return returnLabel(resourcesCMSDataLabel?.Labels, key)
        }
    }

    const fetchCommonCMSLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
            const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
            return returnLabel(commonCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray, key) => {
        if (labelArray.length > 0 && key) {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }
        return '';
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(e) => {
                    /**  e.stopPropagation(); required to use form within form seperately to avoid conflicts between nested form submits. */
                    e.stopPropagation();
                    rhfFormInstanceForPDSubFolderAdd.handleSubmit(onSubmitForPDSubFolderAdd)(e)
                }}
            >
                <DialogTitle>
                    {/* Create Sub-Folder */}
                    {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.CreateSubFolder')}
                </DialogTitle>
                <DialogContent>
                    <MpgInput
                        rhfFormInstance={rhfFormInstanceForPDSubFolderAdd}
                        name={"folder_name"}
                        //label={"Folder Name"}
                        label={fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.FolderName')}
                        fullWidth
                        disabled
                    />
                    <MpgInput
                        rhfFormInstance={rhfFormInstanceForPDSubFolderAdd}
                        name={"sub_folder_name"}
                        //label={"SubFolder Name"}
                        label={fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.SubFolderName')}
                        fullWidth
                    />
                    {
                        <FormHelperText error={!!errorMsg}>
                            {errorMsg}
                        </FormHelperText>
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            handleClose()
                        }}
                    >
                        {fetchCommonCMSLabel ("Common.Cancel")}
                    </Button>

                    <Button
                        type="submit"
                        disabled={!!disableSubmitButton}
                    >
                        {fetchCommonCMSLabel ("Common.OK")}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}
export default AddSubFolderActionDialog